import { render, staticRenderFns } from "./IssueBox.vue?vue&type=template&id=31fb279c"
import script from "./IssueBox.vue?vue&type=script&lang=js"
export * from "./IssueBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports